import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { SharedService } from '../_service/shared.service';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
    private userrole:string;cm_access='';loginUserId:string;
    constructor(private sharedapi: SharedService,private myRoute: Router){}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        this.sharedapi.getRole()
        .subscribe((item:string) => {
            this.userrole = item;
        });

        this.sharedapi.getCMAccess()
        .subscribe((item:string) => {this.cm_access=item;});

        this.userrole = localStorage.getItem('role');
        this.cm_access = localStorage.getItem('CMAccess');
        this.loginUserId = localStorage.getItem('loginuserId');
        //console.log(this.userrole);
        //console.log(this.cm_access);
        let pageUrl= route.routeConfig.path;
        if(this.userrole=='5')
        {
            if(pageUrl.includes('ipds') || pageUrl.includes('electives') || pageUrl.includes('insurance') || pageUrl.includes('hospitals') || pageUrl.includes('hospital') || pageUrl.includes('reports/ipd-transaction-report') || pageUrl.includes('tpa') || pageUrl.includes('booked-meeting-rooms') || pageUrl.includes('add-meeting-room') || pageUrl.includes('update-meeting-room/:id'))
            {
                return true;
            }else{
                this.sharedapi.presentToast('Access Denied!');
                this.myRoute.navigate(['dashboard']);
                return false;
            }
        }
        
        /* else if(this.userrole=='2' || (this.userrole=='3' && this.cm_access!='1')){
            if(pageUrl.includes('users') || pageUrl.includes('create-user') || pageUrl.includes('update-user/:user_id')){
               this.sharedapi.presentToast('Access Denied!');
                this.myRoute.navigate(['dashboard']);
                return false;
            }else{
                return true;
            }
        } */
        
        else if(this.userrole=='6')
        {
            if(pageUrl.includes('reports/lead-keyword-report') || pageUrl.includes('leads') || pageUrl.includes('ipds') || pageUrl.includes('hospitals') || pageUrl.includes('doctors') || pageUrl.includes('update-hospital/:hospital_id') || pageUrl.includes('update-doctor/:doctor_id') || pageUrl.includes('locations')|| pageUrl.includes('create-location')|| pageUrl.includes('update-location/:location_id')|| pageUrl.includes('location') || pageUrl.includes('treatments') || pageUrl.includes('update-treatment/:treatment_id') || pageUrl.includes('view-lead/:lead_id') || pageUrl.includes('reports/status-wise-report') || pageUrl.includes('opds') || pageUrl.includes('booked-meeting-rooms') || pageUrl.includes('add-meeting-room') || pageUrl.includes('update-meeting-room/:id') || pageUrl.includes('corporate-lead-lists') || pageUrl.includes('add-corporate-lead') || pageUrl.includes('update-corporate-lead/:id') || pageUrl.includes('scan-booked-list') || pageUrl.includes('sheetview') ||  pageUrl.includes('manage-circle-city') || pageUrl.includes('update-circle-cities') || pageUrl.includes('add-ipd-feedback') || pageUrl.includes('electives') || (pageUrl.includes('insurance') &&  this.loginUserId=='58') || (pageUrl.includes('glamyo-patients') &&  this.loginUserId=='58') || (pageUrl.includes('glamyo-patients') &&  this.loginUserId=='58') || pageUrl.includes('members') || (pageUrl.includes('add-member-transaction')) || (pageUrl.includes('create-lead') &&  this.loginUserId=='595') || pageUrl.includes('create-hospital') || pageUrl.includes('create-doctor') || pageUrl.includes('manage-bridge-number-list') || pageUrl.includes('specialties') || pageUrl.includes('create-specialties') || pageUrl.includes('update-specialties/:speciality_id') || pageUrl.includes('feedback-report')|| pageUrl.includes('products')||(pageUrl.includes('users') && (this.loginUserId=='58' ||this.loginUserId=='631' || this.loginUserId=='595' ||this.loginUserId=='709')) || pageUrl.includes('hair-removal'))
            {
                return true;
            }else{
                this.sharedapi.presentToast('Access Denied!');
                this.myRoute.navigate(['dashboard']);
                return false;
            }
        }
        else if(this.userrole=='7')
        {
            if(pageUrl.includes('ipds') || pageUrl.includes('opds')  || pageUrl.includes('scan-booked-list'))
            {
                return true;
            }else{
                this.sharedapi.presentToast('Access Denied!');
                this.myRoute.navigate(['opds']);
                return false;
            }
        }
        else if(this.userrole=='10')
        {
            if(pageUrl.includes('doctors') || pageUrl.includes('hospitals') || pageUrl.includes('create-hospital') || pageUrl.includes('update-hospital')  || pageUrl.includes('complaints') || pageUrl.includes('knowledge-base') || pageUrl.includes('ipds'))
            {
                return true;
            }else{
                this.sharedapi.presentToast('Access Denied!');
                this.myRoute.navigate(['dashboard']);
                return false;
            }
        }
        else if(this.userrole=='12')
        {
            if(pageUrl.includes('leads') || pageUrl.includes('patient-journey-tracker') || pageUrl.includes('discharged-patient-journey-tracker')){
                return true;
            }else{
                this.sharedapi.presentToast('Access Denied!');
                this.myRoute.navigate(['leads']);
                return false;
            }
            
        }else if(this.userrole=='19')
        {
            if(pageUrl.includes('scan-booked-list')){
                return true;
            }else{
                this.sharedapi.presentToast('Access Denied!');
                this.myRoute.navigate(['scan-booked-list']);
                return false;
            }
        }else if(this.userrole=='20')
        {
            if(pageUrl.includes('dental-report/orthodontist-delivery') || pageUrl.includes('ods-scan-logs')){
                return true;
            }else{
                this.sharedapi.presentToast('Access Denied!');
                this.myRoute.navigate(['dashboard']);
                return false;
            }
        }else if(this.userrole=='21')
        {
            if(pageUrl.includes('scan-booked-list') || pageUrl.includes('update-scan/:lead_id')){
                return true;
            }else{
                this.sharedapi.presentToast('Access Denied!');
                this.myRoute.navigate(['dashboard']);
                return false;
            }
        }else if(this.userrole=='17')
        {
            if(pageUrl.includes('dashboard') || pageUrl.includes('doctors') || pageUrl.includes('hospitals') || pageUrl.includes('leads') || pageUrl.includes('add-lab-lead') || pageUrl.includes('lab-sheetview') || pageUrl.includes('lab-list') || pageUrl.includes('opds') || pageUrl.includes('ipds') || pageUrl.includes('electives') || pageUrl.includes('knowledge-base') || pageUrl.includes('affiliate-users') || pageUrl.includes('affiliate-leads') || pageUrl.includes('affiliate-opds') || pageUrl.includes('affiliate-ipds')){
                return true;
            }else{
                this.sharedapi.presentToast('Access Denied!');
                this.myRoute.navigate(['dashboard']);
                return false;
            }
        }
        
        else{
                return true;
        }
  }




}
